import { useState, useEffect, useCallback } from 'react';

const API_URL = process.env.NODE_ENV === 'production'
  ? (process.env.REACT_APP_PRODUCTION_API_URL || 'https://api.kundlishastra.com')
  : (process.env.REACT_APP_API_URL || 'http://localhost:5001');

/**
 * Shastra AI “first question free” — UI hint only, drives CTA copy so pricing
 * never needs to be hardcoded on the frontend. The backend
 * (`POST /api/payments/create-order`) is the source of truth and re-verifies
 * eligibility server-side before ever bypassing payment.
 */
export function useFreeQuestionEligibility(userId) {
  const [freeQuestionAvailable, setFreeQuestionAvailable] = useState(false);

  const refresh = useCallback(async () => {
    if (!userId) {
      setFreeQuestionAvailable(false);
      return;
    }
    try {
      const res = await fetch(
        `${API_URL}/api/payments/kundli-question-eligibility?userId=${encodeURIComponent(userId)}`
      );
      const data = await res.json();
      setFreeQuestionAvailable(!!(data && data.success && data.freeQuestionAvailable));
    } catch {
      setFreeQuestionAvailable(false);
    }
  }, [userId]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { freeQuestionAvailable, setFreeQuestionAvailable, refreshFreeQuestionEligibility: refresh };
}
